import React, {useEffect, useState} from 'react';
import { Routes, Route } from 'react-router-dom';
import { supabase } from '../services/supabase'; // adjust path if needed
import Landing from '../pages/Landing';
import Login from '../components/auth/Login';
import Signup from '../components/auth/Signup';
import Dashboard from '../pages/Dashboard';
import ProfileForm from '../pages/ProfileForm';
import ChatPage from '../pages/ChatPage';
import History from '../pages/History';
import AuthCallback from '../pages/AuthCallback';
//import SupportUs from '../pages/supportus';
import Subscription from '../pages/Subscription';
import CourseRegistration from '../pages/CourseRegistration';

const AppRoutes: React.FC = () => {
  const [session, setSession] = useState<any>(null);

  useEffect(() => {
    // Check active session on load
    supabase.auth.getSession().then(({data}) => {
      setSession(data.session);
    });

    // Listen for login/logout
    const {data: {subscription}} = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  return (
    <Routes>
      {/* Conditional home route */}
      <Route path="/" element={session ? <Dashboard /> : <Landing />} />

      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/courses" element={<CourseRegistration />} />
      <Route path="/profile" element={<ProfileForm />} />
      <Route path="/chat/:chatType" element={<ChatPage />} />
      <Route path="/history" element={<History />} />
      <Route path="/subscription" element={<Subscription />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
    </Routes>
  );
};

export default AppRoutes;

